import { Component, OnDestroy, OnInit } from '@angular/core';
import { SignupStepperService } from '@app/modules/signup-new/services/signup-stepper.service';
import { SignupUserService } from '@app/modules/signup-new/services/signup-user.service';
import { SignupWizardService } from '@app/modules/signup-new/services/signup-wizard.service';
import { BehaviorSubject, Subscription, timer } from 'rxjs';
import { finalize } from 'rxjs/operators';

const COOLDOWN_DURATION_SECONDS = 30;

@Component({
  selector: 'sbnb-signup-validate-mobile-page',
  templateUrl: './signup-validate-mobile-page.component.html',
})
export class SignupValidateMobilePageComponent implements OnInit, OnDestroy {
  otp = '';
  otpSize = 6;
  cooldownTimeSeconds = COOLDOWN_DURATION_SECONDS;
  cooldownActive = false;
  cooldownSubscription: Subscription;
  codeRecentlyRequested$ = new BehaviorSubject<boolean>(false);
  isValidating = false;
  isRequestingNewCode = false;

  constructor(
    public signupUserService: SignupUserService,
    private signupWizardService: SignupWizardService,
    private signupStepperService: SignupStepperService
  ) {}

  ngOnInit(): void {
    this.startCooldown();
  }

  ngOnDestroy() {
    if (this.cooldownSubscription) {
      this.cooldownSubscription.unsubscribe();
    }
  }

  onContinue() {
    if (this.otp.length !== this.otpSize) return;

    this.isValidating = true;
    this.signupUserService
      .validatePhone(this.otp)
      .pipe(finalize(() => (this.isValidating = false)))
      .subscribe(() => {
        this.signupWizardService.next('validate-mobile');
        this.signupStepperService.complete('Details');
      });
  }

  requestNewCode() {
    if (this.isRequestingNewCode) return;

    this.isRequestingNewCode = true;
    this.signupUserService
      .requestNewOtp()
      .pipe(finalize(() => (this.isRequestingNewCode = false)))
      .subscribe(() => this.setCodeRecentlyRequested());
  }

  startCooldown() {
    this.cooldownActive = true;

    this.cooldownSubscription = timer(0, 1000).subscribe((seconds) => {
      this.cooldownTimeSeconds = COOLDOWN_DURATION_SECONDS - seconds;
      if (this.cooldownTimeSeconds <= 0) {
        this.cooldownSubscription.unsubscribe();
        this.cooldownActive = false;
      }
    });
  }

  setCodeRecentlyRequested() {
    this.codeRecentlyRequested$.next(true);

    timer(3000).subscribe(() => {
      this.codeRecentlyRequested$.next(false);
      this.startCooldown();
    });
  }
}
